import GLTFLoader from 'three-gltf-loader';

import { REACT_APP_HEBI_API_BASE_URL } from '../../../app/config/env-config';
import { promisifyLoader } from './three-utils';

const GltfLoader = new GLTFLoader();
GltfLoader.setPath(REACT_APP_HEBI_API_BASE_URL);

export default promisifyLoader(GltfLoader);
